import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsOpsgenieRoute: InvariantJiraRoute = {
	name: 'classic-software-link-opsgenie',
	path: '/jira/software/c/projects/:projectKey/settings/opsgenie',
	exact: true,
};
